import React from "react";

const benefits = [
  "Increase customer engagement",
  "Improve brand visibility",
  "Simplify bookings and purchases",
  "Offer faster customer support",
  "Automate business processes",
  "Build customer loyalty",
];

export default function Section5() {
  return (
    <div className="w-full Section5 py-[35px] bg-[#F5F5F5]">
      <div className="container-1280 section5-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Why Businesses in the UAE Need Mobile Apps
        </h2>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-6">
          Mobile apps help businesses create direct connections with
          customers.
        </p>

        <p className="text-center font-bold text-[#151515] text-sm md:text-base font-open mb-5">
          A well-built app can help you:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
          {benefits.map((item) => (
            <div
              key={item}
              className="bg-white border-l-[3px] border-[#cd2122] rounded-[6px] px-4 py-3 text-xs md:text-sm font-open text-[#535353]"
            >
              {item}
            </div>
          ))}
        </div>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open">
          From retail stores in Dubai to service companies in Abu Dhabi,
          businesses are using mobile apps to improve the way they serve
          customers.
        </p>
      </div>
    </div>
  );
}
